/* global dataLayer */
import MultistepWizard from './multistep-wizard.js';

class MultistepWizardHipotecas extends MultistepWizard {
  constructor() {
    super()
    this.isNotFirstProperty = false
    this.tasacionInput = null
    this.solicitadoInput = null
    this.stepFinalidad = null
    this.stepImporteSolicitado = null
    this.stepPhone = null
    this.porcentajeSolicitado = 0
    // Para visibilidad condicional del checkbox de cesión de datos (solo España)
    this.cesionDatosCheckbox = null
    this.cesionDatosContainer = null
    this.cuantoTeCostoInput = null
  }

  connectedCallback() {
    super.connectedCallback()
    this.setupHipotecas()
    this.showStep(this.findStep('start') || this.findStep('finalidad'))
  }

  setupHipotecas() {
    this.tasacionInput = this.querySelector('#captador_simulacion_valor_tasacion')
    this.solicitadoInput = this.querySelector('#captador_simulacion_importe_solicitado')
    this.porcentajeMaximoSugerido = this.solicitadoInput.dataset.porcentajeFinanciacionMaximo
    this.stepFinalidad = this.querySelector('multistep-step[position="finalidad"]')
    this.stepImporteSolicitado = this.querySelector('multistep-step[position="importe_solicitado"]')
    this.pendienteInput = this.querySelector('#captador_simulacion_importe_pendiente_amortizar')
    this.stepPhone = this.querySelector('multistep-step[position="telefono"]')
    this.maxPercentage = this.isNotFirstProperty ? 70 : 90
    this.phoneTitle = this.stepPhone?.querySelector('.rnk-WizardStep_titulo')
    this.phoneTitleAlternative = this.stepPhone?.querySelector('.rnk-WizardStep_titulo-alternative')
    this.phoneDescriptionAlternative = this.stepPhone?.querySelector('.rnk-WizardStep_explicacion-alternative')

    // PDT-RNK-018: cacheamos el progress original del HAML para poder restaurarlo si la
    // vía cambia de brokers a tramitación (cuando el usuario edita el % financiación).
    const phoneIndicator = this.stepPhone?.querySelector('progress-indicator')
    const phonePercent = this.stepPhone?.querySelector('progress-percent')
    this.stepPhoneProgressOriginal = phoneIndicator && phonePercent
      ? { style: phoneIndicator.getAttribute('style') || '', percent: phonePercent.textContent.trim() }
      : null

    // Inicializar elementos para cesión de datos condicional (solo España)
    if (document.documentElement.lang.endsWith('-es')) {
      this.cesionDatosCheckbox = this.querySelector('input[type=checkbox][id=captador_simulacion_acepta_terminos]')
      this.cesionDatosContainer = this.querySelector('[data-cesion-datos-container]')
      this.cuantoTeCostoInput = this.querySelector('#captador_simulacion_cuanto_te_costo')
    }

    this.solicitadoRange = document.createElement('INPUT')
    this.solicitadoHelperNode = document.createElement('SMALL')

    // Setup nodes
    this.tasacionInput.min = 1000
    this.tasacionInput.step = 1
    this.solicitadoInput.step = 1
    this.solicitadoInput.min = 1000
    this.solicitadoRange.type = 'range'
    this.solicitadoRange.step = 1
    this.solicitadoRange.min = 1000
    this.solicitadoRange.value = this.solicitadoRange.min
    this.solicitadoHelperNode.innerHTML = `Te recomendamos solicitar como máximo el ${this.porcentajeMaximoSugerido}% del valor de tasación.`

    // Insert nodes on document
    this.solicitadoInput.parentNode.insertBefore(this.solicitadoRange, this.solicitadoInput.nextElementSibling)
    this.solicitadoInput.closest('multistep-step').querySelector('header').appendChild(this.solicitadoHelperNode)

    // Add listeners
    this.stepFinalidad.addEventListener('change', this.onFinalidadChanged.bind(this))
    this.tasacionInput.addEventListener('input', this.onTasacionChanged.bind(this))
    this.solicitadoInput.addEventListener('input', this.onSolicitadoChanged.bind(this))
    this.stepImporteSolicitado.addEventListener('hide', this.onStepImporteSolicitadoHide.bind(this))

    // After otras_cuotas, all non-sellable fields are available — re-evaluate SMS
    this.stepOtrasCuotas = this.querySelector('multistep-step[position="otras_cuotas"]')
    if (this.stepOtrasCuotas) {
      this.stepOtrasCuotas.addEventListener('hide', this.desactivarSmsSiNoVendible.bind(this))
    }

    // Listeners para cesión de datos condicional (solo España)
    if (document.documentElement.lang.endsWith('-es') && this.cuantoTeCostoInput) {
      this.cuantoTeCostoInput.addEventListener('input', this.actualizarVisibilidadCesionDatos.bind(this))
    }
    if (document.documentElement.lang.endsWith('-es') && this.pendienteInput) {
      this.pendienteInput.addEventListener('input', this.actualizarVisibilidadCesionDatos.bind(this))
    }

    for (let evento of ['input', 'change', 'mousemove', 'touchmove']) {
      this.solicitadoRange.addEventListener(evento, this.onSolicitadoRangeChanged.bind(this))
    }

    // Required on retries
    const inputs = [
      this.pendienteInput,
      this.tasacionInput,
      this.solicitadoInput,
      this.solicitadoRange
    ]
    inputs.forEach(input => {
      if (input?.value) input.dispatchEvent(new CustomEvent('input'))
    })

    this.onFinalidadChanged()
    this.setupVerificacionSmsInline()
  }

  updateHelper(input, helper, defaultTip) {
    if (input.validationMessage) { // on error
      helper.style.color = '#e91101'
      helper.innerHTML = input.validationMessage
    } else {
      helper.style.color = '#58a8da'
      helper.innerHTML = defaultTip || '&nbsp;'
    }
  }

  updatePhoneTextHelper () {
    if (document.documentElement.lang.endsWith('-es')) {
      if (!Number.isFinite(this.porcentajeSolicitado) || this.porcentajeSolicitado === 0 || this.stepPhone === null) return

      if (this.porcentajeSolicitado >= this.maxPercentage) {
        this.phoneTitle.classList.add('hidden')
        this.phoneTitleAlternative.classList.remove('hidden')
        this.phoneDescriptionAlternative.classList.remove('hidden')
      } else {
        this.phoneTitle.classList.remove('hidden')
        this.phoneTitleAlternative.classList.add('hidden')
        this.phoneDescriptionAlternative.classList.add('hidden')
      }
    }
  }

  onFinalidadChanged() {
    if (document.documentElement.lang.endsWith('-es')){
      const formData = new FormData(this.querySelector('form'))
      const selectedValue = formData.get('captador_simulacion[finalidad]')
      if (selectedValue === null) return

      const solicitadoDescription = this.stepImporteSolicitado.querySelector('.rnk-WizardStep_explicacion')
      const solicitadoDescriptionAlternative = this.stepImporteSolicitado.querySelector('.rnk-WizardStep_explicacion-alternative')
      if (selectedValue === 'Comprar segunda vivienda' || selectedValue === 'Invertir') {
        this.isNotFirstProperty = true
        solicitadoDescription.classList.add('hidden')
        solicitadoDescriptionAlternative.classList.remove('hidden')
      } else {
        this.isNotFirstProperty = false
        solicitadoDescription.classList.remove('hidden')
        solicitadoDescriptionAlternative.classList.add('hidden')
      }
      this.maxPercentage = this.isNotFirstProperty ? 70 : 90
      this.actualizarVisibilidadCesionDatos()
    }
  }
  onStepImporteSolicitadoHide(){
    this.porcentajeSolicitado = Math.floor(this.solicitadoInput.valueAsNumber / this.tasacionInput.valueAsNumber * 100)
    this.updatePhoneTextHelper(this.porcentajeSolicitado)
    this.actualizarVisibilidadCesionDatos()
    this.actualizarSmsObligatorio()
  }

  onTasacionChanged() {
    const max = this.tasacionInput.valueAsNumber
    const maxSugerido = Math.floor(this.tasacionInput.valueAsNumber * parseInt(this.porcentajeMaximoSugerido) / 100)

    this.solicitadoInput.max = max
    this.solicitadoInput.value = maxSugerido
    this.solicitadoInput.dispatchEvent(new CustomEvent('input'))
    this.solicitadoRange.max = max
    this.solicitadoRange.value = maxSugerido
    this.solicitadoRange.dispatchEvent(new CustomEvent('input'))
  }

  onSolicitadoChanged() {
    const porcentajeActual = Math.floor(this.solicitadoInput.valueAsNumber / this.tasacionInput.valueAsNumber * 100)
    const helperText = `Estarías solicitando una financiación del <b>${porcentajeActual}%</b> .`

    this.porcentajeSolicitado = porcentajeActual
    this.solicitadoRange.value = this.solicitadoInput.valueAsNumber
    this.updateHelper(this.solicitadoInput, this.solicitadoHelperNode, helperText)
    this.updatePhoneTextHelper()
  }

  onSolicitadoRangeChanged () {
    if (this.solicitadoRange.valueAsNumber < parseInt(this.solicitadoRange.max)) {
      // emulate a step of 100 while lower than max
      // (so, admit hundreds and the max value)
      this.solicitadoRange.value = Math.ceil(this.solicitadoRange.valueAsNumber / 100) * 100
    }
    this.solicitadoInput.value = this.solicitadoRange.value
    this.solicitadoInput.dispatchEvent(new CustomEvent('input'))
  }

  // Override to avoid scroll to top
  scrollToTop() {}

  // === Métodos para visibilidad condicional del checkbox de cesión de datos (solo España) ===

  getUmbralCesionDatos(finalidad) {
    const umbrales = {
      'Comprar vivienda': 85,
      'Comprar segunda vivienda': 70,
      'Invertir': 50,
      'Autopromoción': 90,
      'Subrogar o mejorar condiciones': 80
    }
    return umbrales[finalidad] || 80
  }

  // La cesión a terceros solo se ofrece si hay terceros a los que ceder. La lista de
  // cesión solo contiene brokers hipotecarios (TC-124-2.2.11.24), y solo hay brokers
  // con financiación > 80% (Asistente::Simulacion#partners_para_cesion): por debajo el
  // popup de entidades saldría vacío y el consentimiento no tendría destinatario.
  // Cuando el motor de reparto (US-124-2.2.14) resuelva los brokers por reglas de
  // negocio, esta visibilidad pasará a depender de la lista resuelta, no de umbrales.
  debeOfrecerCesionDeDatos(finalidad) {
    const PORCENTAJE_MINIMO_CON_BROKERS = 81
    const porcentaje = this.calcularPorcentajeFinanciacion(finalidad)
    const umbral = Math.max(this.getUmbralCesionDatos(finalidad), PORCENTAJE_MINIMO_CON_BROKERS)
    return porcentaje >= umbral
  }

  esFinalidadSubrogacion(finalidad) {
    return finalidad === 'Subrogar o mejorar condiciones'
  }

  calcularPorcentajeFinanciacion(finalidad) {
    if (this.esFinalidadSubrogacion(finalidad)) {
      const cuantoTeCosto = this.cuantoTeCostoInput?.valueAsNumber || 0
      const importePendiente = this.pendienteInput?.valueAsNumber || 0
      return cuantoTeCosto > 0 ? Math.floor(importePendiente / cuantoTeCosto * 100) : 0
    }
    const tasacion = this.tasacionInput?.valueAsNumber || 0
    const solicitado = this.solicitadoInput?.valueAsNumber || 0
    return tasacion > 0 ? Math.floor(solicitado / tasacion * 100) : 0
  }

  actualizarSmsObligatorio() {
    if (!document.documentElement.lang.endsWith('-es')) return
    if (!this.stepPhone) return

    const formData = new FormData(this.querySelector('form'))
    const finalidad = formData.get('captador_simulacion[finalidad]')
    if (!finalidad || this.esFinalidadSubrogacion(finalidad)) {
      this.smsRequerido = false
      this.actualizarLayoutBrokers()
      return
    }

    const porcentaje = this.calcularPorcentajeFinanciacion(finalidad)
    const umbral = this.getUmbralCesionDatos(finalidad)
    this.smsRequerido = porcentaje >= umbral && porcentaje > 0
    this.actualizarLayoutBrokers()
  }

  // Called after otras_cuotas step (all non-sellable fields are now filled).
  // Overrides smsRequerido to false if the lead is non-sellable.
  // Reads inputs directly (not FormData) because int-local-format stores display values with locale separators.
  desactivarSmsSiNoVendible() {
    if (!this.smsRequerido) return

    const importe = this.solicitadoInput?.valueAsNumber || 0
    const ingresosInput = this.querySelector('#captador_simulacion_ingresos_mensuales')
    const ingresos = ingresosInput?.valueAsNumber || 0
    const situacionRadio = this.querySelector('input[name="captador_simulacion[situacion_laboral]"]:checked')
    const situacion = situacionRadio?.value || ''

    if (importe < 60000 || ingresos < 1200 || ['Desempleado', 'Pensionista'].includes(situacion)) {
      this.smsRequerido = false
      this.actualizarLayoutBrokers()
    }
  }

  // PDT-RNK-018: en la vía brokers el paso teléfono+cesión es el hito de conversión real,
  // por lo que mostramos la barra al 100 % y el botón "Enviar" en vez de "Siguiente". En la
  // vía tramitación se conserva el comportamiento original (porcentaje calculado y "Siguiente").
  actualizarLayoutBrokers() {
    if (!this.stepPhone) return

    const indicator = this.stepPhone.querySelector('progress-indicator')
    const percent = this.stepPhone.querySelector('progress-percent')
    const buttonLabel = this.stepPhone.querySelector('label[id^="siguiente"] .button-like-nav__label')

    if (this.smsRequerido) {
      indicator?.setAttribute('style', 'width: 100%')
      if (percent) percent.textContent = '100%'
      if (buttonLabel) buttonLabel.textContent = 'Enviar'
    } else {
      // Restaura el progress original que viene del HAML server-rendered
      if (indicator && this.stepPhoneProgressOriginal) indicator.setAttribute('style', this.stepPhoneProgressOriginal.style)
      if (percent && this.stepPhoneProgressOriginal) percent.textContent = this.stepPhoneProgressOriginal.percent
      if (buttonLabel) buttonLabel.textContent = 'Siguiente'
    }
  }

  // === Verificación SMS inline ===

  setupVerificacionSmsInline() {
    if (!this.stepPhone) return

    this.smsRequerido = false
    this.smsValidado = false
    this.smsEntityId = null

    this.smsPhoneInput = this.stepPhone.querySelector('.sms-phone-input')
    this.smsCodeEntry = this.stepPhone.querySelector('.sms-code-entry')
    this.smsPhoneDisplay = this.stepPhone.querySelector('.sms-phone-display')
    this.smsCodeInput = this.stepPhone.querySelector('[data-sms-code-input]')
    this.smsError = this.stepPhone.querySelector('.sms-error')
    // Header y footer se buscan en cada toggle (no cachear, posible timing issue en connectedCallback)

    if (!this.smsCodeEntry) return

    const verifyBtn = this.stepPhone.querySelector('[data-sms-verify]')
    const changePhoneLink = this.stepPhone.querySelector('[data-sms-change-phone]')

    verifyBtn.addEventListener('click', () => this.verificarCodigo())
    changePhoneLink.addEventListener('click', (e) => {
      e.preventDefault()
      this.mostrarEstadoSms('phone')
    })

    this.smsCodeInput.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault()
        this.verificarCodigo()
      }
    })

    this.stepPhone.addEventListener('next', (e) => this.interceptarSubmitParaSms(e))

    this.stepPhone.addEventListener('show', () => {
      if (!this.smsValidado) this.mostrarEstadoSms('phone')
    })
  }

  interceptarSubmitParaSms(event) {
    if (!this.smsRequerido || this.smsValidado) return

    event.stopPropagation()
    this.enviarSms()
  }

  get simulacionIdStorageKey() {
    return 'captador_hipotecas_simulacion_id'
  }

  // `int-local-format` mostramos el número con separadores de miles en el input
  // ("125000" → "125.000"). El listener 'submit' de `multistep-answers`
  // (`_setupNumericInput`) lo devuelve a su originalValue() antes de enviar el
  // form. Como aquí enviamos el form vía `fetch` sin disparar el evento submit,
  // hay que aplicar la misma normalización manualmente o el backend recibe
  // "125.000" y `lead_no_vendible?` interpretaría 125 < 60.000 como no vendible.
  normalizeIntLocalFormatInputs() {
    this.form.querySelectorAll('input[is="int-local-format"]').forEach(input => {
      if (typeof input.originalValue === 'function') {
        input.value = input.originalValue()
      }
    })
  }

  async enviarSms() {
    const phoneWithPrefix = this.stepPhone.querySelector('phone-with-prefix')
    if (!phoneWithPrefix) return

    const telefono = phoneWithPrefix.telefonoCompleto
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    this.normalizeIntLocalFormatInputs()
    const formData = new FormData(this.form)
    formData.set('telefono', telefono)
    formData.set('path', [...this.path].reverse().join())
    const simulacionId = sessionStorage.getItem(this.simulacionIdStorageKey)
    if (simulacionId) formData.set('simulacion_id', simulacionId)

    try {
      const response = await fetch('/captadores/simulaciones/hipotecas/enviar_sms', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json',
          'X-CSRF-Token': csrfToken,
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      })

      if (!response.ok) {
        const data = await response.json().catch(() => ({}))
        alert(data.error || 'Error al enviar SMS. Por favor, inténtalo de nuevo.')
        return
      }

      const data = await response.json()
      this.smsEntityId = data.sms_id
      if (data.simulacion_id) sessionStorage.setItem(this.simulacionIdStorageKey, data.simulacion_id)
      this.smsPhoneDisplay.textContent = telefono
      this.mostrarEstadoSms('code')
      // La simulación ya está creada y enviada a HubSpot en este punto. La validación SMS
      // solo se pide en vía broker, así que disparar captador_completed en la transición a
      // este paso es equivalente a "una vez por sesión en vía broker", contabilizando también
      // a los leads que abandonan antes de verificar el código.
      this.nofitySuccessToGA()
      // Guard sobre `dataLayer`: si GTM no se carga (dev local sin consent,
      // bloqueador, fallo de red en el script de Didomi/GTM, etc.) la
      // referencia lanzaba ReferenceError dentro de este try y caía al
      // catch genérico mostrando "Error al enviar SMS" aunque el SMS sí se
      // había enviado y la simulación estaba creada. Reportado Naiara/Paco
      // 2026-05-13 en localhost:7004.
      if (typeof dataLayer !== 'undefined') {
        dataLayer.push({
          event: 'GAEvent',
          eventCategory: 'captadores',
          eventAction: 'sms_verification_shown',
          eventLabel: 'hipotecas',
          eventValue: 0
        })
      }
      this.smsCodeInput.value = ''
      this.smsError.classList.add('hidden')
      this.smsCodeInput.focus()
    } catch (e) {
      console.error('[hipotecas-wizard] fallo tras enviar SMS:', e)
      alert('Error al enviar SMS. Por favor, inténtalo de nuevo.')
    }
  }

  async verificarCodigo() {
    const token = this.smsCodeInput.value.trim()
    if (token.length !== 4) {
      this.smsError.classList.remove('hidden')
      this.smsCodeInput.classList.add('sms-code-entry__input--error')
      return
    }

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    try {
      const response = await fetch('/telefono/validar-sms', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-CSRF-Token': csrfToken
        },
        body: JSON.stringify({ id: this.smsEntityId, token })
      })

      if (response.ok) {
        this.smsValidado = true
        await this.completarSimulacion()
      } else {
        this.smsError.classList.remove('hidden')
        this.smsCodeInput.classList.add('sms-code-entry__input--error')
        this.smsCodeInput.value = ''
        this.smsCodeInput.focus()
      }
    } catch {
      this.smsError.classList.remove('hidden')
    }
  }

  async completarSimulacion() {
    this.terminado = true
    const simulacionId = sessionStorage.getItem(this.simulacionIdStorageKey)
    if (!simulacionId) {
      // Fallback si por cualquier motivo no tenemos simulacion_id (refresco del navegador con el flujo en curso)
      this.form.commit.click()
      return
    }

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    this.normalizeIntLocalFormatInputs()
    const formData = new FormData(this.form)
    formData.set('path', this.path.join())

    document.body.dataset.loading = 'Procesando'
    window.scrollTo(0, 0)
    this.frameAutoheight()
    // El flujo legacy oculta el form en el listener 'submit' de _wizard_intro.haml.
    // Aquí lo replicamos a mano porque interceptarSubmitParaSms() detiene la propagación
    // del submit y enviamos via fetch directo, así que ese listener nunca dispara.
    this.form.style.display = 'none'

    try {
      const response = await fetch(`/captadores/simulaciones/hipotecas/${simulacionId}/completar`, {
        method: 'PATCH',
        credentials: 'same-origin',
        headers: { 'X-CSRF-Token': csrfToken, 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })

      if (!response.ok) throw response

      const html = await response.text()
      this.results.innerHTML = html
      this.results.querySelectorAll('script').forEach(script => {
        const newScript = document.createElement('script')
        newScript.textContent = script.textContent
        script.replaceWith(newScript)
      })
      delete document.body.dataset.loading
      window.scrollTo(0, 0)
      this.frameAutoheight()
      sessionStorage.removeItem(this.simulacionIdStorageKey)
      if (typeof this.ajaxSuccessCallback === 'function') this.ajaxSuccessCallback()
    } catch {
      delete document.body.dataset.loading
      alert('Error al completar la simulación. Por favor, inténtalo de nuevo.')
    }
  }

  mostrarEstadoSms(state) {
    if (!this.smsPhoneInput) return

    const isPhone = state === 'phone'
    const isCode = state === 'code'

    this.smsPhoneInput.classList.toggle('hidden', !isPhone)
    this.smsCodeEntry.classList.toggle('hidden', !isCode)

    // Buscar header/footer directamente del DOM (no cachear, evita timing issues en connectedCallback)
    const header = this.stepPhone.querySelector('.rnk-WizardStep_Header')
    const footer = this.stepPhone.querySelector('.rnk-WizardStep_Footer')
    header?.classList.toggle('hidden', isCode)
    footer?.classList.toggle('hidden', isCode)
  }

  actualizarVisibilidadCesionDatos() {
    // Solo aplica a España
    if (!document.documentElement.lang.endsWith('-es')) return
    if (!this.cesionDatosContainer || !this.cesionDatosCheckbox) return

    const formData = new FormData(this.querySelector('form'))
    const finalidad = formData.get('captador_simulacion[finalidad]')
    if (!finalidad) return

    if (this.debeOfrecerCesionDeDatos(finalidad)) {
      this.cesionDatosContainer.classList.remove('hidden')
      this.cesionDatosCheckbox.disabled = false
    } else {
      this.cesionDatosContainer.classList.add('hidden')
      this.cesionDatosCheckbox.checked = false
      this.cesionDatosCheckbox.disabled = true
    }
  }
}

export default MultistepWizardHipotecas;
